import { makeObservable, action, observable, computed } from 'mobx';
import MkMessNotifRequests from 'Utils/Requests/MkMessNotifRequests'
import { ShowAlert } from "Utils/CommonFunctions";
import Enumerable from "linq";

class MkMessagingStore {
    messageTitle;
    messageBody;
    messageSettings;
    newMessageStore;
    /** @type {Object.<number, string>} */
    usersNamesByIdsDict;
    /** @type {number[]} */
    newMessageSelectedUsersIds;
    /** @type {number[]} */
    newMessageSelectingUsersModalSelectedUsersIds;
    modal;
    navigateFromMessageDetails;
    newMessageCreationInProcess;

    limitTitle = 200;
    limitBody = 2000;

    lineBreakWindows = "\r\n";
    lineBreakLinux = "\n";

    constructor() {
        makeObservable(this, {
            messageTitle: observable,
            messageBody: observable,
            messageSettings: observable,
            newMessageStore: observable,
            usersNamesByIdsDict: observable,
            newMessageSelectedUsersIds: observable,
            newMessageSelectingUsersModalSelectedUsersIds: observable,
            modal: observable,
            navigateFromMessageDetails: observable,
            newMessageCreationInProcess: observable,
            newMessageHasChanges: computed
        });

        this.newMessageCreationInProcess = false;
        this.navigateFromMessageDetails = false;
        this.usersNamesByIdsDict = {};
        this.ClearNewMessageInfo();
        this.modal = {
            show: false,
            type: ''
        };
    }

    get newMessageHasChanges() {
        return (
            this.messageBody != ''
            || this.messageTitle != ''
            || this.newMessageSelectedUsersIds.length > 0
            || this.messageSettings.messageExpiredDate != null
        );
    }

    ClearNewMessageInfo = action(_ => {
        this.messageBody = '';
        this.messageTitle = '';
        this.messageSettings = {};
        this.ClearNewMessageUsersInfo();
        this.newMessageStore = {
            dateTimePickerDropDownState: {}
        };
    });

    ClearNewMessageUsersInfo = action(_ => {
        this.newMessageSelectedUsersIds = [];
        this.newMessageSelectingUsersModalSelectedUsersIds = [];
    });

    HandleTitleInput = action(e => {
        let value = this.LineBreaksRemove(e.target.value);

        if (value.length > this.limitTitle) {
            value = value.substring(0, this.limitTitle);
            ShowAlert('error', 'Превышено допустимое количество символов');
        }

        this.messageTitle = value;
    });

    LoadUsersToSelect() {
        MkMessNotifRequests.GetActiveUsers()
            .then(action(data => {
                this.usersNamesByIdsDict = data;
            }));
    }

    SelectUsersModalGetUsersIdsNotSelected() {
        return Enumerable.from(Object.keys(this.usersNamesByIdsDict)).except(this.newMessageSelectingUsersModalSelectedUsersIds).toArray();
    }

    GetSelectedUsersByIds(ids) {
        return (
            Enumerable
                .from(ids)
                .select(id => ({
                    id: id,
                    userName: this.usersNamesByIdsDict[id]
                }))
                .orderBy(it => it.userName)
                .toArray()
        );
    }

    HandleBodyInput = action(e => {
        let value = this.LineBreaksConvertToWindows(e.target.value);

        if (value.length > this.limitBody) {
            value = value.substring(0, this.limitBody);
            ShowAlert('error', 'Превышено допустимое количество символов');
        }

        this.messageBody = value;
    });

    SendMessage = action(() => {
        this.newMessageCreationInProcess = true;

        MkMessNotifRequests.CreateMessage({
            title: this.messageTitle,
            body: this.messageBody,
            expiredDate: this.messageSettings.messageExpiredDate,
            SelectedUsersId: this.newMessageSelectedUsersIds
        }).then(action(result => {
            if (result.isSuccess) {
                if (result.addresseListChanged) {
                    this.alertAfterNavigation = {
                        type: 'warning',
                        text: 'Сообщение создано, но некоторые адресаты были исключены из списка получателей, поскольку они были логически удалены.'
                    };
                }
                else {
                    this.alertAfterNavigation = {
                        type: 'success',
                        text: 'Сообщение успешно создано.'
                    };
                }

                this.navigateFromMessageDetails = true;
            } else {
                if (result.realAdressessEmpty == true) {
                    this.ClearNewMessageUsersInfo();
                    this.LoadUsersToSelect();
                    ShowAlert('warning', 'Сообщение не создано, потому что в списке получателей нет активированных пользователей.');
                }
                else if (result.expiredDateTimeLessThanToday == true) {
                    ShowAlert('warning', 'Срок действия сообщения не может быть меньше текущего времени. Пожалуйста, выберите корректную дату и время.');
                }
                else {
                    ShowAlert('error', 'При попытке создания сообщения произошла ошибка.');
                }
            }
        })).finally(action(() => this.newMessageCreationInProcess = false));
    });

    ResetNavigateFromMessageDetails = action(_ => {
        if (!this.navigateFromMessageDetails) return;

        if (this.alertAfterNavigation != null)
            ShowAlert(this.alertAfterNavigation.type, this.alertAfterNavigation.text);

        this.navigateFromMessageDetails = false;
        this.alertAfterNavigation = null;
    });

    LineBreaksRemove = (str) =>
        str.replaceAll(this.lineBreakWindows, "").replaceAll(this.lineBreakLinux, "");

    LineBreaksConvertToWindows = (str) =>
        str.replaceAll(this.lineBreakLinux, this.lineBreakWindows)
            .replaceAll(
                this.lineBreakWindows.replaceAll(this.lineBreakLinux, this.lineBreakWindows),
                this.lineBreakWindows);
}

export default new MkMessagingStore();